module.exports = "<app-header-view></app-header-view>\r\n\r\n<section class=\"full_width_background bg_img bgi01 clearfix\" id=\"subHeader\">\r\n\t<h1 class=\"text-white\">UIK - Universal Interactive Kit</h1>\r\n\t<h3 class=\"text-white m-b-20\">Content</h3>\r\n</section>\r\n\r\n<app-footer-view></app-footer-view>"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-template/user-template.component.html
// module id = ./src/app/user-template/user-template.component.html
// module chunks = main